import React, {useState} from "react"
import {RouterSwitch} from "./RouterSwitch";
import {Route} from "react-router";
import {useTranslation} from "react-i18next";
import {UserContext} from '../../context/UserContext'
import Auth from "../../auth/Auth";
import Footer from "./Footer";
import Content from "./Content";
import Error404 from "./Error404";
import TopBar from "./TopBar";
import ContactAdministratorError from "./ContactAdministratorError";
import Landing from "../pages/landing/Landing";
import {Provider} from "react-redux";
import store from "../../state/store";
import RegistrationForm from "../../auth/RegistrationForm";
import Instruction from "../pages/Instruction";
import Drawer from "../pages/Drawer";
import {ModalProvider} from "../../context/ModalProvider";
import UserProfile from "../pages/UserProfile";
import Notifications from "../../../../common/src/components/widget/Notifications";

export const RouteContext = React.createContext(null);

const ApplicationStateful = () => {
    const {t} = useTranslation();
    const routesState = useState({routes: [], breadcrumbs: []});
    const [user, setUser] = useState({});

    return (
        <RouteContext.Provider value={routesState}>
            <UserContext.Provider value={{user, setUser}}>
                <Provider store={store}>
                    <ModalProvider>
                        <Notifications>

                        <Auth>
                            <TopBar/>
                            <Drawer/>
                            <div id="main-section" className="is-main-section-container">
                                <Content >
                                    <RouterSwitch>
                                        <Route path="/" element={<Landing/>}/>
                                        <Route path="/profile" element={<UserProfile/>}/>
                                        <Route path="/register" element={<RegistrationForm/>}/>
                                        <Route path="/instructions" element={<Instruction/>}/>
                                        <Route path="account-error"
                                               element={<ContactAdministratorError/>}/>
                                        <Route path="*" element={<Error404/>}/>
                                    </RouterSwitch>
                                </Content>
                                <Footer/>
                            </div>
                        </Auth>
                        </Notifications>

                    </ModalProvider>

                </Provider>
            </UserContext.Provider>
        </RouteContext.Provider>
    )
}

export default ApplicationStateful;

